export default __webpack_public_path__ + "static/Presentacion31-df3ca2d4ab2bc87328327b6e5886130d.pdf";